import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    gridDetails: {
        marginBottom: 10
    },
    iconGrid: {
        textAlign: 'left',
        paddingLeft: 10
    },
    root: {
        marginLeft: 0,
        marginRight: 10,
        marginTop: 15,
    }
}))
